document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.add-to-cart-wrap')) {


        

        var checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.id = 'age-confirmation-checkbox';
        checkbox.style.marginRight = '10px';
        checkbox.style.accentColor = '#e92929';

        var label = document.createElement('label');
        label.htmlFor = 'age-confirmation-checkbox';
        label.innerText = 'Tick this box to confirm that you, as well as the person receiving this order, are over the age of 18';
        label.prepend(checkbox);

        var container = document.createElement('div');
        container.style.marginBottom = '10px';
        container.appendChild(label);
        

        var addToCartWrap = document.querySelector('.add-to-cart-wrap');
        addToCartWrap.parentNode.insertBefore(container, addToCartWrap);

        addToCartWrap.style.opacity = '0.5';
        addToCartWrap.style.pointerEvents = 'none';

        //also .additional-checkout-buttons

        let additional_wrap = document.querySelector('.additional-checkout-buttons');
        if (additional_wrap) {
            additional_wrap.style.opacity = '0.5';
            additional_wrap.style.pointerEvents = 'none';
        }

        //enable the add to cart button when the checkbox is checked
        checkbox.addEventListener('change', function () {
            addToCartWrap.style.opacity = checkbox.checked ? '1' : '0.5';
            addToCartWrap.style.pointerEvents = checkbox.checked ? 'auto' : 'none';
            additional_wrap.style.opacity = checkbox.checked ? '1' : '0.5';
            additional_wrap.style.pointerEvents = checkbox.checked ? 'auto' : 'none';
        });
    }
});